<template>
	<span v-if="!changes.length" class="d-flex">
		<menu-icon
			name="station_settings"
			color="currentColor"
			edge-size="18"
			class="me-2"
		/>
		Змін не виявлено (збережено без змін)
	</span>
	<span v-else>
		<span class="d-flex">
			<menu-icon
				v-if="!changes[0].isCreation"
				name="station_settings"
				color="currentColor"
				edge-size="18"
				class="me-2"
			/>
			Користувач "<span class="fw-bolder">{{ changes[0].user }}</span>" 
			{{ changes[0].isCreation ? 'створив станцію' : 'змінив' }}
		</span>
		<ul>
			<li v-for="change in changes" :key="change.path">
				{{ change.group === null ? settingName(change.group, change.path) : groupName(change.group) }}	
				<template v-for="[index, value] in change.settingKeys.entries()" :key="change.path + index + value">
					<br/>
					<span v-if="change.group !== null">
						{{ settingName(change.group, change.settingKeys[index]) }}:&nbsp;
					</span>
					<station-passport-change-record
						v-if="!changes[0].isCreation"
						:station-id="stationId"
						:value="change.prev[index]"
						:setting-id="change.settingKeys[index]"
						:unit="change.group"
					/>
					&nbsp;
					<svg
						v-if="!changes[0].isCreation"
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						fill="currentColor"
						class="bi bi-arrow-right"
						viewBox="0 0 16 16"
					>
						<path
							fill-rule="evenodd"
							d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
						/>
					</svg>
					&nbsp;
					<station-passport-change-record
						:station-id="stationId"
						:value="change.current[index]"
						:setting-id="change.settingKeys[index]"
						:unit="change.group"
					/>
				</template>
			</li>
		</ul>
	</span>
</template>




<script>
import { toRaw } from 'vue'
import MenuIcon from '@/components/Icons/MenuIcon.vue'
import StationPassportChangeRecord from '@/components/EventsSection/StationPassportChangeRecord.vue'
import { Station } from '@/models/station.js'


export default {
	components: {
		MenuIcon,
		StationPassportChangeRecord,
	},

	props: {
		state: {
			type: Object,
			required: true,
			default: () => ({}),
		},

		prevState: {
			type: Object,
			required: false,
			default: null,
		},

		// Flatten path
		ignoreFields: {
			type: Array,
			required: false,
			default: () => [],
		},

		// Flatten path
		// Using if allowFields.length > 0 
		allowFields: {
			type: Array,
			required: false,
			default: () => [],
		},
	},

	setup() {
		const settingGroupKeys = Object.keys(Station.passportKeys).filter(key => {
			const value = Station.passportKeys[key]
			return value !== null && typeof value === 'object' && !Array.isArray(value)
		}).map((key) => Station.passportKeys[key].self)

		return {
			settingGroupKeys,
			unitKeys: Object.keys(Station.unitNames)
		}
	},

	methods: {
		isPlainObject(value) {
			return Object.prototype.toString.call(value) === '[object Object]'
		},

		flattenState(source, parentPath = [], result = {}) {
			// If wrong input
			if (!this.isPlainObject(source)) {
				return result
			}

			const ignoredFields = new Set(this.ignoreFields)
			const allowFields = new Set(this.allowFields)
			const keys = Object.keys(source)

			if (!keys.length && parentPath.length) {
				result[parentPath.join('.')] = source
				return result
			}

			keys.forEach((key) => {
				const value = toRaw(source[key]) // stop reactivity of value
				const currentPath = [...parentPath, key]

				if (ignoredFields.has(currentPath.join('.'))) {
					return
				}
				if (this.allowFields.length > 0 && !allowFields.has(currentPath.join('.'))) {
					return
				}

				if (this.isPlainObject(value)) {
					this.flattenState(value, currentPath, result)
					return
				}

				result[currentPath.join('.')] = value
			})

			return result
		},

		settingName(group, settingKey) {
			if (settingKey == Station.passportKeys.departmentId) {
				// return this.accountStore.organization.department_title ? 
				// 	this.accountStore.organization.department_title :
				// 	Station.departmentDefaultTitle
				return Station.departmentDefaultTitle
			} else if (settingKey == Station.passportKeys.sectorId) {
				// return this.accountStore.organization.sector_title ? 
				// 	this.accountStore.organization.sector_title :
				// 	Station.sectorIdDefaultTitle
				return Station.sectorIdDefaultTitle
			} else if (settingKey == `${Station.passportKeys.location}.coordinates`) {
				return 'Місце розташування'
			// If group is unit
			// } else if (group !== null && Object.keys(Station.unitNames).includes(group)) {
			// 	debugger
			// 	return Station[group]?.settingNames[settingKey] ?? 'невідоме налаштування модуля'
			} else if (group !== null) {
				return this.unitKeys.includes(group)
					? Station.settingNames[group][settingKey]
					: Station.settingNames[settingKey]
			} else {
				return Station.settingNames[settingKey] ?? settingKey
			}
		},

		groupName(group) {
			return this.unitKeys.includes(group)
				? Station.unitNames[group]
				: Station.settingNames[group].self
		},
	},

	computed: {
		stationId() {
			return this.state[Station.passportKeys.id]
		},

		changes() {
			const current = this.flattenState(this.state)
			const user = this.state[Station.passportKeys.updateBy]?.name || this.state[Station.passportKeys.creatorId]?.name
			const previous = this.flattenState(this.prevState || {})
			const paths = new Set([...Object.keys(previous), ...Object.keys(current)])
	
			// Filter only changed fields
			const atomicChanges = [...paths]
				.filter((path) => {
					const prevValue = previous[path]
					const nextValue = current[path]
					return JSON.stringify(prevValue) !== JSON.stringify(nextValue)
				})

			// Group changes by bussines logic
			const goupedChanges = []
			let prevGroupKey
			for (const path of atomicChanges.sort()) {
				const prevGroup = goupedChanges[goupedChanges.length - 1]
				const path0 = path.split('.')[0]
				const curGroupKey = this.settingGroupKeys.includes(path0) ? path0 : null

				// If current path is in same group with previous path
				if (curGroupKey !== null && curGroupKey == prevGroupKey) {
					// Add curent setting to previous group
					prevGroup.settingKeys.push(path.split('.')[1])
					prevGroup.prev.push(previous[path])
					prevGroup.current.push(current[path])
					continue
				}
				
				// If current path not in previous group
				goupedChanges.push({
					isCreation: this.state[Station.passportKeys.passportVersion] == 1,
					path,
					group: curGroupKey,
					user,
					settingKeys: [curGroupKey == null ? path.split('.')[0] : path.split('.')[1]],
					prev: [previous[path]],
					current: [current[path]],
				})

				prevGroupKey = curGroupKey
			}
			// console.log('goupedChanges', this.settingGroupKeys,  goupedChanges)

			return goupedChanges
		},
	},
}
</script>